import React from 'react';
import type { RefObject } from 'react';

import { v4 as uuidv4 } from 'uuid';

import Konva from 'konva';

import { FlexBox, GridBox } from '@eltoro-ui/components';

import type { CanvasElement, ShapeElement } from 'Components/CanvasEditor/types';

const shapes = [
  { id: 'rectangle', type: 'rect', title: 'Rectangle' },
  { id: 'circle', type: 'circle', title: 'Circle' },
  { id: 'line', type: 'line', title: 'Line' },
];

interface ShapesProps {
  stageRef: RefObject<Konva.Stage>;
  onAddElement: (element: CanvasElement) => void;
}

export default function Shapes({ stageRef, onAddElement }: ShapesProps) {
  const onAddShape = (type: ShapeElement['type']) => () => {
    const stage = stageRef.current;
    if (!stage) return;
    if (type === 'rect') {
      const x = (stage.width() - 150) / 2;
      const y = (stage.height() - 100) / 2;

      onAddElement({
        id: uuidv4(),
        type,
        x,
        y,
        fill: '#4B5563',
        stroke: '#000000',
        strokeWidth: 0,
        rotation: 0,
        draggable: true,
        width: 150,
        height: 100,
        cornerRadius: 0,
        visible: true,
      });
    }

    if (type === 'circle') {
      const x = (stage.width() - 100) / 2;
      const y = (stage.height() - 100) / 2;

      onAddElement({
        id: uuidv4(),
        type,
        x,
        y,
        fill: '#4B5563',
        stroke: '#000000',
        strokeWidth: 0,
        rotation: 0,
        draggable: true,
        radiusX: 50,
        radiusY: 50,
        visible: true,
      });
    }

    if (type === 'line') {
      const x = (stage.width() - 100) / 2;
      const y = (stage.height() - 100) / 2;

      onAddElement({
        id: uuidv4(),
        type,
        x,
        y,
        stroke: '#4B5563',
        strokeWidth: 5,
        rotation: 0,
        draggable: true,
        closed: false,
        points: [0, 0, 100, 0],
        fill: 'transparent',
        visible: true,
      });
    }
  };
  return (
    <FlexBox flexDirection="column" UNSAFE_className="element-examples-container" gap="0.75rem">
      <span className="section-title">Shapes</span>
      <GridBox gridTemplateColumns="repeat(2, 1fr)" gap="0.75rem">
        {shapes.map(({ id, title, type }) => (
          <button
            key={id}
            className="shape-element-card"
            onClick={onAddShape(type as ShapeElement['type'])}
          >
            <div className={`shape-element ${type}`} />
            <span className="element-label">{title}</span>
          </button>
        ))}
      </GridBox>
    </FlexBox>
  );
}
